export default __webpack_public_path__ + "static/media/dispersion.c0103ed8.svg";